import { Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import HeaderFicheEEPBM from './HeaderFicheEEPBM';
import PreparationEEPBM from './PreparationEEPBM';
import { User } from 'src/models/user/user.model';
import { CURRENT_USER } from 'src/constants';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useState } from 'react';
import { boondService, businessManagerService } from 'src/services';
import { EepBMModel } from 'src/models/businessManager/businessManager.model';
import SuspenseLoader from 'src/components/SuspenseLoader';
import { eaService } from 'src/services';
import ASMAlert from 'src/components/Alert';
import { BusinessManagerContext } from 'src/contexts/BusinessManagerContext';
import { skillsEvaluation } from 'src/services';
import DialogWarningEEP from 'src/components/Dialog/FicheEA/DialogWarningEEP';
import DialogConfirmationSubmitEA from 'src/components/Dialog/DialogConfirmationSubmitEA';
import { EaContext } from 'src/contexts/EaContext';
import { ActionContext } from 'src/contexts/ActionContext';
import { userService } from 'src/services';
import ASMDialogConfirmation from 'src/components/Dialog/ASMDialogConfirmation';
import { EEPLanguageContext } from 'src/contexts/EEPLanguageContext';
import DialogBoondError from 'src/components/Dialog/FicheEA/DialogBoondError';

function FicheEEPBM() {
    const { REACT_APP_NOTIFICATION_DURATION } = process.env;
    const params = useParams();
    const { t, i18n } = useTranslation();
    const currentCulture = i18n.language === 'fr' ? 1 : 2;
    const userData: User = JSON.parse(localStorage.getItem(CURRENT_USER));
    const [data, setData] = useState<EepBMModel>({});
    const [loading, setLoading] = useState(true);
    const [displayAlert, setDisplayAlert] = useState<boolean>(false);
    const [displayAlertError, setDisplayAlertError] = useState<boolean>(false);
    const [displayWarning, setDisplayWarning] = useState<boolean>(false);
    const [displayDialogConfirmation, setDisplayDialogConfirmation] = useState<boolean>(false);
    const [displayDialogConfirmationSendBoond, setDisplayDialogConfirmationSendBoond] = useState<boolean>(false);
    const [openDialogDraft, setOpenDialogDraft] = useState<boolean>(false);
    const [displayBoondError, setDisplayBoondError] = useState<boolean>(false);
    const [errorMessageBoond, setErrorMessageBoond] = useState<string>(t('action.errorValidationAndBoond'));
    const [displayDialogConfirmationValidation, setDisplayDialogConfirmationValidation] = useState<boolean>(false);
    const {
        toggleAction,
        hasManagerPermission,
        isUserHimSelf,
        setIsUserHimSelfContext,
        setHasManagerPermissionContext,
        setHasManagerPermissionResendBoondContext
    } = useContext(ActionContext);
    const {
        setMobilityDataKOContext,
        setInterviewDateNManagerKOContext
    } = useContext(EaContext);
    const {
        eepBMData, setEepBMDataContext,
        BDSkillsData,
        SCSkillsData,
        RCSkillsData,
        MHSkillsData,
        GCSkillsData,
        POSkillsData,
        BMSkillsData,
        CMSkillsData,
        EPSkillsData,
        setBDSkillsDataKOContext,
        setSCSkillsDataKOContext,
        setRCSkillsDataKOContext,
        setMHSkillsDataKOContext,
        setGCSkillsDataKOContext,
        setPOSkillsDataKOContext,
        setBMSkillsDataKOContext,
        setCMSkillsDataKOContext,
        setEPSkillsDataKOContext,
        setIdBusinessManagerContext
    } = useContext(BusinessManagerContext);
    const {
        EEPLanguageDataKO,
        setEEPLanguage
    } = useContext(EEPLanguageContext);
    useEffect(() => {
        let request = {
            idUser: userData.id,
            year: params.year,
            idLang: currentCulture
        };
        if (params.id != undefined) {
            if (parseInt(params.id) == userData.id) {
                setIsUserHimSelfContext(true);
            }
            request = {
                idUser: parseInt(params.id),
                year: params.year,
                idLang: currentCulture
            };

            userService.hasManagerPermission(params.id, 'EEPBM').then(response => {
                if (response.data.success) {
                    setHasManagerPermissionContext(response.data.data.managerAutorisation);
                    setHasManagerPermissionResendBoondContext(response.data.data.resendBoondAutorisation);
                }
            });
        }

        businessManagerService.getEepBmDetails(request).then(response => {
            if (response.data.success && response.data.data != null) {
                setData(response.data.data)
                setEepBMDataContext(response.data.data)
                setIdBusinessManagerContext(response.data.data.idBusinessManager ?? 0)
            } else {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }
        }).catch(err => {
            setDisplayAlertError(true)
            setTimeout(() => {
                setDisplayAlertError(false);
            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
        }).finally(() => {
            setLoading(false)
        });
    }, []);
    const handleClickSaveEepBM = async (loadAfterSaving = true, forSubmission = false, forValidation = false, skipSave = false) => {
        if (skipSave) {
            return;
        }
        toggleAction();
        setLoading(true)
        // save EEP skills
        let eaSkillData = {
            bdskills: BDSkillsData,
            scskills: SCSkillsData,
            rcskills: RCSkillsData,
            mhskills: MHSkillsData,
            gcskills: GCSkillsData,
            poskills: POSkillsData,
            bmskills: BMSkillsData,
            cmskills: CMSkillsData,
            epskills: EPSkillsData
        }
        let idUser = params.id != undefined ? parseInt(params.id) : userData.id;
        await setEEPLanguage();
        skillsEvaluation.updateEaSkillData(eaSkillData, idUser).then(response => {
            if (response.data.success) {
                if (loadAfterSaving) {
                    setDisplayAlert(true)
                    setTimeout(() => {
                        setDisplayAlert(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            } else {
                if (loadAfterSaving) {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }
            // save EEP global
            if (eepBMData.birthDate == '') {
                eepBMData.birthDate = null;
            }
            if (eepBMData.hireDate == '') {
                eepBMData.hireDate = null;
            }
            if (eepBMData.interviewDate == '') {
                eepBMData.interviewDate = null;
            }
            if (eepBMData.interviewDatePrevYear == '') {
                eepBMData.interviewDatePrevYear = null;
            }
            if (eepBMData.functionEntryDate == '') {
                eepBMData.functionEntryDate = null;
            }
            eepBMData.updatedBy = userData.id;
            eaService.updateEepBM(eepBMData).then(response => {
                if (response.data.success) {
                    if (loadAfterSaving) {
                        setDisplayAlert(true)
                        setTimeout(() => {
                            setDisplayAlert(false);
                        }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                    }
                } else {
                    if (loadAfterSaving) {
                        setDisplayAlertError(true)
                        setTimeout(() => {
                            setDisplayAlertError(false);
                        }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                    }
                }
            }).catch(err => {
                if (loadAfterSaving) {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            })
            // 
        }).catch(err => {
            if (loadAfterSaving) {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }
        }).finally(() => {
            // if (loadAfterSaving) {
            //     if (params.id != undefined) {
            //         window.location.href = "/page/eep/bm/fiche/" + params.year + "/" + params.id;
            //     } else {
            //         window.location.href = "/page/eep/bm/fiche/" + params.year + "/" + userData.id;
            //     }
            // }
            setLoading(false)
            if (forSubmission) {
                checkEEPData('submit')
            } else if (forValidation) {
                checkEEPData('validate')
            }
        });
        // end save EEP skills
    }

    const cancel = () => {
        toggleAction();
        window.location.href = "/page/eep/bm/fiche/" + params.year + "/" + params.id;
    }

    const submitEEPBM = () => {
        let action = 'submit';
        eaService.updateEaStatus(data.id, action).then(response => {
            if (response.data.success) {
                //Début Envoie mail
                // /!\ sendMailEEP
                //End Envoie mail
                setDisplayAlert(true);
                setDisplayDialogConfirmation(false);
                // reload after submit & validate
                setTimeout(() => {
                    setDisplayAlert(false);
                    window.location.href = "/page/eep/bm/fiche/" + params.year + "/" + params.id;
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            } else {
                setDisplayAlertError(true);
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }
        }).catch(err => {
            setDisplayAlertError(true);
            setTimeout(() => {
                setDisplayAlertError(false);
            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
        });

    }

    const handleChangeToDraftStatus = () => {
        let action = 'toDraft';
        eaService.updateEaStatus(data.id, action).then(response => {
            if (response.data.success) {
                setDisplayAlert(true);
                setOpenDialogDraft(false);
                // reload after submit & validate
                setTimeout(() => {
                    setDisplayAlert(false);
                    if (hasManagerPermission) {
                        window.location.href = "/management/manager";
                    } else {
                        if (params.id != undefined) {
                            window.location.href = "/page/eep/bm/fiche/" + params.year + "/" + params.id;
                        } else {
                            window.location.href = "/page/eep/bm/fiche/" + params.year + "/" + userData.id;
                        }
                    }
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            } else {
                setDisplayAlertError(true);
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }
        }).catch(err => {
            setDisplayAlertError(true);
            setTimeout(() => {
                setDisplayAlertError(false);
            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
        });

    }

    const handleChangeToValidateStatus = () => {
        let action = 'validate';
        eaService.updateEaStatus(data.id, action).then(async response => {
            if (response.data.success) {
                setDisplayDialogConfirmationValidation(false);
                await sendToBoond(); // boond
                // reload after submit & validate
                setDisplayAlert(true);
                setTimeout(() => {
                    setDisplayAlert(false);
                    window.location.href = "/page/eep/bm/fiche/" + params.year + "/" + params.id;
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            } else {
                setDisplayAlertError(true);
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }
        }).catch(err => {
            setDisplayAlertError(true);
            setTimeout(() => {
                setDisplayAlertError(false);
            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
        });

    }
    const closeDialogBoondError = () => {
        setDisplayBoondError(false)
        window.location.href = "/page/eep/bm/fiche/" + params.year + "/" + params.id;
    }
    const sendToBoond = async () => {
        setLoading(true);
        setDisplayDialogConfirmationSendBoond(false);

        let successActions = false;

        let messageActions = "";
        // begin actions
        let dateAction = '';
        let date = new Date();
        let day = date.getDate().toString();
        day = parseInt(day) < 10 ? ('0' + day) : day;
        let month = (date.getMonth() + 1).toString();
        month = parseInt(month) < 10 ? ('0' + month) : month;
        let year = date.getFullYear();
        dateAction = year + '-' + month + '-' + day;
        await boondService.resendDoActionsAsync(userData.id, params.id, dateAction, '', false, true, currentCulture, params.year, data.idBusinessManager ?? 0).then(async res => {
            if (res.data.data.success) {
                successActions = true;

            } else {
                successActions = false;
                messageActions = res.data.data.statusCode + " " + res.data.data.message;

                // begin send mail error
                await boondService.sendEmailErrorSendBoond(params.id, "actions_ea", messageActions).then(res => {

                }).catch(err => {

                });
                // end send mail error
            }
        }).catch(async err => {

            successActions = false;
            messageActions = err.response.status + " " + err.response.data.message;
            // begin send mail error
            await boondService.sendEmailErrorSendBoond(params.id, "actions_ea", messageActions).then(res => {

            }).catch(err => {

            });
            // end send mail error
        });
        // end actions
        if (successActions) {
            setLoading(false);
            setDisplayAlert(true);
            setTimeout(() => {
                setDisplayAlert(false);
            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            setTimeout(() => {
                window.location.href = "/page/eep/bm/fiche/" + params.year + "/" + params.id;
            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
        } else {
            setLoading(false);
            setErrorMessageBoond(messageActions)
            setDisplayBoondError(true)
        }
    }

    const checkEEPData = (action) => {
        businessManagerService.checkEEPData(params.id, params.year, isUserHimSelf).then(response => {
            if (response.data.success) {
                setMobilityDataKOContext(response.data.data.mobilityDataKO)
                setInterviewDateNManagerKOContext(response.data.data.interviewDateNManagerKO)
                setBDSkillsDataKOContext(response.data.data.bdSkillsDataKO)
                setSCSkillsDataKOContext(response.data.data.scSkillsDataKO)
                setRCSkillsDataKOContext(response.data.data.rcSkillsDataKO)
                setMHSkillsDataKOContext(response.data.data.mhSkillsDataKO)
                setGCSkillsDataKOContext(response.data.data.gcSkillsDataKO)
                setPOSkillsDataKOContext(response.data.data.poSkillsDataKO)
                setBMSkillsDataKOContext(response.data.data.bmSkillsDataKO)
                setCMSkillsDataKOContext(response.data.data.cmSkillsDataKO)
                setEPSkillsDataKOContext(response.data.data.epSkillsDataKO)
                if (action == 'submit' ?
                    (response.data.data.mobilityDataKO
                        || response.data.data.bdSkillsDataKO
                        || response.data.data.scSkillsDataKO
                        || response.data.data.rcSkillsDataKO
                        || response.data.data.mhSkillsDataKO
                        || response.data.data.gcSkillsDataKO
                        || response.data.data.poSkillsDataKO
                        || response.data.data.bmSkillsDataKO
                        || response.data.data.cmSkillsDataKO
                        || response.data.data.epSkillsDataKO
                        || EEPLanguageDataKO)
                    :
                    (response.data.data.interviewDateNManagerKO
                        || response.data.data.bdSkillsDataKO
                        || response.data.data.scSkillsDataKO
                        || response.data.data.rcSkillsDataKO
                        || response.data.data.mhSkillsDataKO
                        || response.data.data.gcSkillsDataKO
                        || response.data.data.poSkillsDataKO
                        || response.data.data.bmSkillsDataKO
                        || response.data.data.cmSkillsDataKO
                        || response.data.data.epSkillsDataKO
                        || EEPLanguageDataKO)
                ) {
                    setDisplayWarning(true)
                }
                else {
                    if (action == 'submit') {
                        setDisplayDialogConfirmation(true)
                    } else {
                        setDisplayDialogConfirmationValidation(true)
                    }
                }
            }
        }).catch(err => {

        });
    }

    const submit = () => {
        handleClickSaveEepBM(false, true, false)
    }

    const validateSendBoondSigned = () => {
        handleClickSaveEepBM(false, false, true)
    }
    return (
        <>
            <Helmet>
                <title>My Skills | {t('ea.title')}</title>
            </Helmet>
            {loading && (
                <>
                    <SuspenseLoader />
                </>
            )}
            <Container maxWidth="lg" >
                <DialogBoondError
                    message={t('action.messageSendBoondKoEa')}
                    display={displayBoondError}
                    handleClose={closeDialogBoondError}
                    details={errorMessageBoond}
                    guide={t('action.guideResendBoond')}
                />
                <ASMAlert message={t('action.success')} severity="success" open={displayAlert} />
                <ASMAlert message={t('action.error')} severity="error" open={displayAlertError} />
                <DialogWarningEEP
                    displayWarning={displayWarning}
                    handleCloseWarning={() => setDisplayWarning(false)}
                    EEPBM={true}
                />
                <DialogConfirmationSubmitEA
                    open={displayDialogConfirmation}
                    onConfirm={submitEEPBM}
                    onClose={() => setDisplayDialogConfirmation(false)}
                />
                <ASMDialogConfirmation
                    title={t('button.resendDraft')}
                    text={t('dialog.textResendDraftEA')}
                    open={openDialogDraft}
                    onConfirm={handleChangeToDraftStatus}
                    onClose={() => setOpenDialogDraft(false)}
                    data={1}
                />
                <ASMDialogConfirmation
                    title={t('action.sendBoondEATitle')}
                    text={t('action.sendBoondEAText')}
                    open={displayDialogConfirmationSendBoond}
                    onConfirm={sendToBoond}
                    onClose={() => setDisplayDialogConfirmationSendBoond(false)}
                />
                <ASMDialogConfirmation
                    title={t('ea.validationLabel')}
                    text={t('ea.validationMessage')}
                    open={displayDialogConfirmationValidation}
                    onConfirm={handleChangeToValidateStatus}
                    onClose={() => setDisplayDialogConfirmationValidation(false)}
                />
                <HeaderFicheEEPBM
                    idEEPBM={data.id ?? 0}
                    idBusinessManager={data.idBusinessManager ?? 0}
                    data={{
                        id: data.id ?? 0,
                        idUser: data.idUser ?? 0,
                        reference: data.reference ?? '',
                        fullName: data.fullName ?? '',
                        title: data.title ?? '',
                        year: data.year ?? '',
                        idStatus: data.idStatus ?? 0,
                        status: data.status ?? ''
                    }}
                    handleClickSaveEepBM={handleClickSaveEepBM}
                    cancel={cancel}
                />
                <PreparationEEPBM
                    idEEPBM={data.id ?? 0}
                    idStatus={data.idStatus ?? 0}
                    submitEEPBM={submit}
                    resendDraft={() => setOpenDialogDraft(true)}
                    resendBoond={() => setDisplayDialogConfirmationSendBoond(true)}
                    validateSendBoondSigned={validateSendBoondSigned}
                    idBusinessManager={data.idBusinessManager ?? 0}
                    businessManagerName={data.businessManagerName ?? ''}
                    employeeIdentityData={{
                        // Employee Identity
                        lastName: data.lastName ?? '',
                        firstName: data.firstName ?? '',
                        birthDate: data.birthDate != null ? data.birthDate.split('T')[0] : '',
                        hireDate: data.hireDate != null ? data.hireDate.split('T')[0] : '',
                        manager: data.manager ?? '',
                        // Cadre de l'entretien
                        interviewDate: data.interviewDate != null ? data.interviewDate.split('T')[0] : '',
                        year: data.year ?? '',
                        interviewDatePrevYear: data.interviewDatePrevYear != null ? data.interviewDatePrevYear.split('T')[0] : '',
                        // Métier
                        position: data.position ?? '',
                        entity: data.entity ?? '',
                        functionEntryDate: data.functionEntryDate != null ? data.functionEntryDate.split('T')[0] : '',
                        degree: data.degree ?? '',
                        degreeObtainPeriod: data.degreeObtainPeriod ?? '',
                        experience: data.experience ?? ''
                    }}
                    skillsAssessment={{
                        strengthsManager: data.strengthsManager ?? '',
                        areasOfProgress: data.areasOfProgress ?? '',
                        actionsToBeImplemented: data.actionsToBeImplemented ?? '',
                    }}
                    professionalProjection={{
                        shortTermGoal: data.shortTermGoal ?? '',
                        shortTermMotivation: data.shortTermMotivation ?? '',
                        shortTermWay: data.shortTermWay ?? '',
                        longTermGoal: data.longTermGoal ?? '',
                        longTermMotivation: data.longTermMotivation ?? '',
                        longTermWay: data.longTermWay ?? '',
                    }}
                    degreeObtainPeriodtherWishes={{
                        mobility: data.mobility ?? '',
                        functionalMobility: data.functionalMobility ?? '',
                        otherWill: data.otherWill ?? '',
                    }}
                    managerComments={data.commentTrainingRequest ?? ''}
                    achievedAndExpectedResults={{
                        rPlus: data.rPlus ?? 0,
                        sign: data.sign ?? 0,
                        oc: data.oc ?? 0
                    }}
                />
                <br />
            </Container>
        </>
    );
}

export default FicheEEPBM;
